export const LESSON_PLAY_IFRAME_PARENT = 'lesson-player';
